import CasesPageMobile from "./CasesPageMobile";

export default CasesPageMobile;
